import {
	type CommonProps,
	type ILogForwarder,
	type LogEntry,
	LogLevel,
	type LogMessage,
	type LogMetadata,
	type LogType,
} from "../types";

export class VoidLogger implements ILogForwarder {
	log(
		_type: LogType,
		_level: LogLevel,
		_injectedProps: CommonProps,
		_message: LogMessage,
		..._metadata: LogMetadata[]
	) {
		// Intentionally empty - void logger does nothing
	}

	logEntry(_entry: LogEntry) {
		// Intentionally empty - void logger does nothing
	}
}
